import React from 'react'
import EnrolledCoursesList from './EnrolledCoursesList'

const EnrolledCourses = () => {
    return (
        <div className='w-full mb-16'>
            <div className='w-full  leading-[30px]'>
                <div className='mb-4 font-bold text-[#151515] text-xl'>Enrolled Courses</div>
                <div>
                    <EnrolledCoursesList />
                </div>
            </div>
        </div>
    )
}

export default EnrolledCourses